import { render, staticRenderFns } from "./ProductionInit.vue?vue&type=template&id=17afd43c&scoped=true"
import script from "./ProductionInit.vue?vue&type=script&lang=js"
export * from "./ProductionInit.vue?vue&type=script&lang=js"
import style0 from "./ProductionInit.vue?vue&type=style&index=0&id=17afd43c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17afd43c",
  null
  
)

export default component.exports